/**
 * React hooks and components for tracking form submissions
 */

import React, { useCallback } from 'react';

import { useCohesion } from '../../CohesionProvider';
import FormSubmittedEvent from './index';

const { createEventPayload } = FormSubmittedEvent;

/**
 * @typedef {import('zod').infer<
 *   typeof import('./index').default.ReactComponentInputSchema
 * >} FormSubmittedEventSchema
 */

/**
 * Hook for tracking form submissions
 *
 * @returns {(eventData: FormSubmittedEventSchema) => void}
 */
export function useTrackFormSubmitted() {
  const { trackEvent } = useCohesion();

  return useCallback(
    (eventData) => {
      const autofillUsed =
        eventData.autofillUsed !== undefined
          ? eventData.autofillUsed
          : eventData.field?.some((field) => field.autofilled) || false;

      trackEvent(
        createEventPayload({
          ...eventData,
          autofillUsed,
        }),
      );
    },
    [trackEvent],
  );
}
